import type { JSX } from 'react';
import { useAppSelector } from '../../../hooks/useReduxToolkit';
import { getRole } from '../../../features/realtime/realtime.selectors';
import { RealtimeRole } from '../../../features/realtime/realtime.types';
import { ExtensionsMainProvider } from './extensionsMainProvider';
import { ExtensionsMainPatient } from './extensionsMainPatient';
import { ExtensionsInitCapabilities } from './extensionsInitCapabilities';

/**
 * Main extensions component, includes hook with basic integration logic.
 * It is not everything you need to integrate extensions, but required part.
 */
export function ExtensionsMain(): JSX.Element | null {
  const role = useAppSelector(getRole);

  // Check for role to render provider or patient specific component.
  // Main has common part (initial capabilities) and different for providers and patients.
  // And render initial capabilities.
  return (
    <>
      {role !== undefined &&
        (role === RealtimeRole.Provider ? (
          <ExtensionsMainProvider />
        ) : (
          <ExtensionsMainPatient />
        ))}

      <ExtensionsInitCapabilities />
    </>
  );
}
